module.exports = __webpack_public_path__ + "static/media/task-operational.fc6aefb4.svg";